import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@material-ui/core';
import { maxWidth, stepSlugs } from '../../config/config';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    justifyContent: 'center',
    display: 'flex',
    backgroundColor: theme.palette.primary.light,
  },
  stepper: {
    backgroundColor: theme.palette.primary.light,
  },
  inner: {
    width: '100%',
    maxWidth: maxWidth + theme.spacing(6),
  },
  steppperLabel: {
    position: 'relative',
    height: '80px',
  },
  steppperLabelText: {
    position: 'absolute',
    transform: 'translateX(-50%)',
    left: '50%',
  },

}));

const StepperBooking = (props) => {
  const classes = useStyles();
  const { activeStep } = props;

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <Stepper className={classes.stepper} activeStep={activeStep} alternativeLabel>
          {stepSlugs.map((slug, i) => (
            <Step key={slug}>
              <StepLabel className={classes.steppperLabel}>
                {activeStep === i
                && (
                  <Typography className={classes.steppperLabelText} component="span" variant="subtitle2">
                    <FormattedMessage id={`StepLabel.${slug}`} />
                  </Typography>
                )}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
  );
};

StepperBooking.propTypes = {
  activeStep: PropTypes.number.isRequired,
};

export default StepperBooking;
